import { render, staticRenderFns } from "./ManageCommodities.vue?vue&type=template&id=835a60f8"
import script from "./ManageCommodities.vue?vue&type=script&lang=ts"
export * from "./ManageCommodities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports